import { DotLegalDialog, DotLegalHeader } from "@dotlegal/dotlegal-ui-components";
import React from "react";
import { Box } from "@mui/material";
import { Trans } from "react-i18next";
import { useTranslation } from "../../../localization/useTranslation";
import useReopenClassificationHooks from "./ReopenClassificationDialog.hooks";
import HighlightedName from "@common/components/HighlightedName";

export interface IReopenClassificationDialog {
    onDialogClose: () => void;
    onInternalAssessmentReopened: () => void;
    classificationId: string;
    name: string;
}

function ReopenClassificationDialog(props: IReopenClassificationDialog) {
    const { translateString } = useTranslation();

    const { onReopenClick, isSaving } = useReopenClassificationHooks(props);

    return (
        <DotLegalDialog
            buttonOkText={translateString("reopen")}
            header={translateString("reopenCompletedClassification")}
            size="sm"
            open
            onDialogClose={props.onDialogClose}
            onOkClick={() => onReopenClick()}
            inProgress={isSaving}
        >
            <Box sx={{ display: "flex", justifyContent: "center" }}>
                <DotLegalHeader fontWeight={400} center headerStyle="small">
                    <Trans
                        i18nKey={"reopenCompletedClassificationContent"}
                        values={{
                            name: props.name.trim(),
                        }}
                        components={{
                            wrapper: <HighlightedName />,
                        }}
                    />
                </DotLegalHeader>
            </Box>
        </DotLegalDialog>
    );
}

export default ReopenClassificationDialog;
